// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xkFL","label":"styles_label__38nCh"};